export default [
  {
    path: '/dashboard/analytics',
    name: 'dashboard-analytics',
    component: () => import('@/views/dashboard/analytics/Analytics.vue'),
  },
  {
    path: '/dashboard',
    name: 'dashboard-toko',
    component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
    meta: { public: true },
  },

  // REPORT
  {
    path: '/dashboard/report/global',
    name: 'dashboard-report-global',
    component: () => import('@/views/dashboard/reports/SalesGlobal.vue'),
    meta: {
      pageTitle: 'Laporan Global Sales',
      breadcrumb: [
        {
          text: 'Laporan Global Sales',
          active: true,
        },
      ],
      resource: 'dashboard-report-global',
      action: 'read',
    },
  },
  {
    path: '/dashboard/report/product',
    name: 'dashboard-report-product',
    component: () => import('@/views/dashboard/reports/ProductGlobal.vue'),
    meta: {
      pageTitle: 'Laporan Global Produk',
      breadcrumb: [
        {
          text: 'Laporan Global Produk',
          active: true,
        },
      ],
      resource: 'dashboard-report-product',
      action: 'read',
    },
  },
  {
    path: '/dashboard/report/refund',
    name: 'dashboard-report-refund',
    component: () => import('@/views/dashboard/reports/SalesRefund.vue'),
    meta: {
      pageTitle: 'Laporan Refund & Nota Batal',
      breadcrumb: [
        {
          text: 'Laporan Batal SO',
          active: true,
        },
      ],
      resource: 'dashboard-report-refund',
      action: 'read',
    },
  },
  {
    path: '/dashboard/report/income-statement',
    name: 'dashboard-report-income-statement',
    component: () => import('@/views/dashboard/reports/IncomeStatement.vue'),
    meta: {
      pageTitle: 'Laporan Laba Rugi',
      breadcrumb: [
        {
          text: 'Laporan Laba Rugi',
          active: true,
        },
      ],
      resource: 'dashboard-report-refund',
      action: 'read',
    },
  },
]
